import mapper from 'utils/simple-mapper'

const mapping = [
  ['teamName'],
  ['sport'],
  ['teamWebsite'],
  ['logo'],
  ['id'],
  ['jurisdiction'],
]

export const toTeamModel = (form) => {
  form.sport = form.sport.id
  form.jurisdiction = form.jurisdiction?.id || form.jurisdiction
  form.logo = form.logo ?? 'football/nz/player/defaultavatar.png'
  return mapper(form, mapping)
}
